module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "page-content",
    attrs: {
      "element-loading-text": "请稍等···"
    }
  }, [_c('el-form', {
    ref: "jobSettingInfo",
    attrs: {
      "model": _vm.jobSettingInfo,
      "rules": _vm.rules,
      "label-width": "140px"
    }
  }, [(_vm.$common.hasPerm('job:update', _vm.domainName)) ? _c('el-button', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "type": "primary",
      "disabled": _vm.jobSettingInfo.enabled
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.updateInfo($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-database"
  }), _vm._v("更新")]) : _vm._e(), _vm._v(" "), _c('el-collapse', {
    model: {
      value: (_vm.activeNames),
      callback: function($$v) {
        _vm.activeNames = $$v
      },
      expression: "activeNames"
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "name": "1"
    }
  }, [_c('template', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("\n                    基本配置\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "job-setting-content"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "jobType",
      "label": "作业类型"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.jobSettingInfo.jobType),
      callback: function($$v) {
        _vm.$set(_vm.jobSettingInfo, "jobType", $$v)
      },
      expression: "jobSettingInfo.jobType"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.$option.isJava(_vm.jobSettingInfo.jobType)) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "jobClass",
      "label": "作业实现类"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.jobSettingInfo.jobClass),
      callback: function($$v) {
        _vm.$set(_vm.jobSettingInfo, "jobClass", $$v)
      },
      expression: "jobSettingInfo.jobClass"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$option.isCron(_vm.jobSettingInfo.jobType)) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "cron",
      "label": "Cron"
    }
  }, [_c('el-tooltip', {
    attrs: {
      "popper-class": "form-tooltip",
      "content": "作业启动时间的cron表达式。如每10秒运行:*/10****?,每5分钟运行:0*/5***?",
      "placement": "bottom"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.jobSettingInfo.cron),
      callback: function($$v) {
        _vm.$set(_vm.jobSettingInfo, "cron", $$v)
      },
      expression: "jobSettingInfo.cron"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append"
    },
    on: {
      "click": _vm.checkAndForecastCron
    },
    slot: "append"
  }, [_vm._v("预测")])], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-annotation"
  }, [_c('span', [_vm._v("1. 每10秒运行一次的表达式：*/10 * * * * ?")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("2. 每分钟运行一次的表达式：0 * * * * ?")])])], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [(!_vm.jobSettingInfo.localMode) ? _c('el-form-item', {
    attrs: {
      "prop": "shardingTotalCount",
      "label": "作业分片数"
    }
  }, [(_vm.jobSettingInfo.downStream) ? _c('el-tooltip', {
    attrs: {
      "popper-class": "form-tooltip",
      "placement": "bottom"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('span', [_vm._v(_vm._s(_vm.jobSettingInfo.downStream.length > 0 ? '该作业有下游作业，作业分片数必须为1' : '作业分片数'))])]), _vm._v(" "), _c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.jobSettingInfo.downStream.length > 0,
      "controls-position": "right",
      "min": 1
    },
    model: {
      value: (_vm.jobSettingInfo.shardingTotalCount),
      callback: function($$v) {
        _vm.$set(_vm.jobSettingInfo, "shardingTotalCount", $$v)
      },
      expression: "jobSettingInfo.shardingTotalCount"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.jobSettingInfo.localMode) ? _c('el-form-item', {
    attrs: {
      "prop": "shardingTotalCount",
      "label": "作业分片数"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "value": "N/A",
      "disabled": ""
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "localMode",
      "label": "本地模式"
    }
  }, [(_vm.jobSettingInfo.downStream) ? _c('el-tooltip', {
    attrs: {
      "popper-class": "form-tooltip",
      "placement": "bottom"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('span', [_vm._v(_vm._s(_vm.jobSettingInfo.downStream.length > 0 ? '该作业有下游作业，不可选为本地模式' : '本地模式'))])]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "disabled": _vm.jobSettingInfo.downStream.length > 0
    },
    model: {
      value: (_vm.jobSettingInfo.localMode),
      callback: function($$v) {
        _vm.$set(_vm.jobSettingInfo, "localMode", $$v)
      },
      expression: "jobSettingInfo.localMode"
    }
  })], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), (_vm.$option.isMsg(_vm.jobSettingInfo.jobType)) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "queueName",
      "label": "Queue名"
    }
  }, [_c('el-tooltip', {
    attrs: {
      "popper-class": "form-tooltip",
      "placement": "bottom"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                                        消息类型job的queue名\n                                    ")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.jobSettingInfo.queueName),
      callback: function($$v) {
        _vm.$set(_vm.jobSettingInfo, "queueName", $$v)
      },
      expression: "jobSettingInfo.queueName"
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "shardingItemParameters",
      "label": "分片参数"
    }
  }, [_c('el-tooltip', {
    attrs: {
      "popper-class": "form-tooltip",
      "placement": "bottom"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                                        分片序列号和参数用等号分隔，多个键值对用逗号分隔 。分片序列号从0开始，不可大于或等于作业分片总数。如：0=a,1=b,2=c;"), _c('br'), _vm._v("\n                                        英文双引号请使用!!代替，英文等号请使用@@代替，英文逗号请使用##代替。"), _c('br'), _vm._v("\n                                        如果作业所有分片无须参数，则只要保持值为0。例如有2个分片无须参数，则为“0=0,1=0”。"), _c('br'), _vm._v("\n                                        对于本地模式的作业，格式为*=value\n                                    ")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.jobSettingInfo.shardingItemParameters),
      callback: function($$v) {
        _vm.$set(_vm.jobSettingInfo, "shardingItemParameters", $$v)
      },
      expression: "jobSettingInfo.shardingItemParameters"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "jobParameter",
      "label": "自定义参数"
    }
  }, [_c('el-tooltip', {
    attrs: {
      "popper-class": "form-tooltip",
      "content": "配置格式: 多个配置使用逗号分隔(key1=value1, key2=value2)。在分片序列号/参数对照表中可作为alias形式引用，格式为{key1}",
      "placement": "bottom"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.jobSettingInfo.jobParameter),
      callback: function($$v) {
        _vm.$set(_vm.jobSettingInfo, "jobParameter", $$v)
      },
      expression: "jobSettingInfo.jobParameter"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "preferList",
      "label": "优先executor"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "multiple": ""
    },
    model: {
      value: (_vm.jobSettingInfo.preferList),
      callback: function($$v) {
        _vm.$set(_vm.jobSettingInfo, "preferList", $$v)
      },
      expression: "jobSettingInfo.preferList"
    }
  }, _vm._l((_vm.preferListProvidedArray), function(item) {
    return _c('el-option', {
      key: item.executorDes,
      attrs: {
        "label": item.executorDes,
        "value": item.executorName
      }
    })
  }))], 1)], 1)], 1), _vm._v(" "), _c('el-row', [(!_vm.jobSettingInfo.localMode) ? _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "onlyUsePreferList",
      "label": "只使用优先executor"
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.jobSettingInfo.onlyUsePreferList),
      callback: function($$v) {
        _vm.$set(_vm.jobSettingInfo, "onlyUsePreferList", $$v)
      },
      expression: "jobSettingInfo.onlyUsePreferList"
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "description",
      "label": "作业描述信息"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.jobSettingInfo.description),
      callback: function($$v) {
        _vm.$set(_vm.jobSettingInfo, "description", $$v)
      },
      expression: "jobSettingInfo.description"
    }
  })], 1)], 1)], 1)], 1)], 2), _vm._v(" "), _c('el-collapse-item', {
    attrs: {
      "name": "2"
    }
  }, [_c('template', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("\n                    高级配置\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "job-setting-content"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "timeout4AlarmSeconds",
      "label": "超时告警(秒)"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.jobSettingInfo.timeout4AlarmSeconds),
      callback: function($$v) {
        _vm.$set(_vm.jobSettingInfo, "timeout4AlarmSeconds", $$v)
      },
      expression: "jobSettingInfo.timeout4AlarmSeconds"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "timeoutSeconds",
      "label": "超时强杀(秒)"
    }
  }, [_c('el-tooltip', {
    attrs: {
      "popper-class": "form-tooltip",
      "placement": "top",
      "effect": "light"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('span', {
    staticClass: "text-warning"
  }, [_vm._v("警告：对于Java作业，立即终止操作（即强杀）会stop业务线程，如果作业代码没有实现onTimeout方法来释放资源，有可能导致资源的不释放，例如数据库连接的不释放。")])]), _vm._v(" "), _c('el-input', {
    model: {
      value: (_vm.jobSettingInfo.timeoutSeconds),
      callback: function($$v) {
        _vm.$set(_vm.jobSettingInfo, "timeoutSeconds", $$v)
      },
      expression: "jobSettingInfo.timeoutSeconds"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "groups",
      "label": "所属分组"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.jobSettingInfo.groups),
      callback: function($$v) {
        _vm.$set(_vm.jobSettingInfo, "groups", $$v)
      },
      expression: "jobSettingInfo.groups"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "loadLevel",
      "label": "作业负荷"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.jobSettingInfo.loadLevel),
      callback: function($$v) {
        _vm.$set(_vm.jobSettingInfo, "loadLevel", $$v)
      },
      expression: "jobSettingInfo.loadLevel"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "processCountIntervalSeconds",
      "label": "统计处理间隔(秒)"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.jobSettingInfo.processCountIntervalSeconds),
      callback: function($$v) {
        _vm.$set(_vm.jobSettingInfo, "processCountIntervalSeconds", $$v)
      },
      expression: "jobSettingInfo.processCountIntervalSeconds"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "timeZone",
      "label": "时区"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": ""
    },
    model: {
      value: (_vm.jobSettingInfo.timeZone),
      callback: function($$v) {
        _vm.$set(_vm.jobSettingInfo, "timeZone", $$v)
      },
      expression: "jobSettingInfo.timeZone"
    }
  }, _vm._l((_vm.jobSettingInfo.timeZonesProvided), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": _vm.$option.isMsg(_vm.jobSettingInfo.jobType) ? 7 : 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "showNormalLog",
      "label": "控制台输出日志"
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.jobSettingInfo.showNormalLog),
      callback: function($$v) {
        _vm.$set(_vm.jobSettingInfo, "showNormalLog", $$v)
      },
      expression: "jobSettingInfo.showNormalLog"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": _vm.$option.isMsg(_vm.jobSettingInfo.jobType) ? 7 : 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "enabledReport",
      "label": "上报运行状态"
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.jobSettingInfo.enabledReport),
      callback: function($$v) {
        _vm.$set(_vm.jobSettingInfo, "enabledReport", $$v)
      },
      expression: "jobSettingInfo.enabledReport"
    }
  })], 1)], 1), _vm._v(" "), (_vm.$option.isMsg(_vm.jobSettingInfo.jobType)) ? _c('el-col', {
    attrs: {
      "span": _vm.$option.isMsg(_vm.jobSettingInfo.jobType) ? 7 : 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "useSerial",
      "label": "串行消费"
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.jobSettingInfo.useSerial),
      callback: function($$v) {
        _vm.$set(_vm.jobSettingInfo, "useSerial", $$v)
      },
      expression: "jobSettingInfo.useSerial"
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.$option.isCron(_vm.jobSettingInfo.jobType) || _vm.$option.isPassive(_vm.jobSettingInfo.jobType)) ? _c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": _vm.$option.isCron(_vm.jobSettingInfo.jobType) ? 11 : 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "failover",
      "label": "故障转移"
    }
  }, [_c('el-switch', {
    attrs: {
      "title": "本地模式或非上报运行状态不可编辑",
      "disabled": _vm.jobSettingInfo.localMode || !_vm.jobSettingInfo.enabledReport
    },
    model: {
      value: (_vm.jobSettingInfo.failover),
      callback: function($$v) {
        _vm.$set(_vm.jobSettingInfo, "failover", $$v)
      },
      expression: "jobSettingInfo.failover"
    }
  })], 1)], 1), _vm._v(" "), (_vm.$option.isCron(_vm.jobSettingInfo.jobType)) ? _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "rerun"
    }
  }, [_c('div', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('span', [_vm._v("过时未跑重试")]), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "placement": "top",
      "content": "不建议高频作业启动超时重跑",
      "effect": "light",
      "popper-class": "allocation-popper"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle"
  })])], 1), _vm._v(" "), _c('el-switch', {
    attrs: {
      "title": "非上报运行状态不可编辑",
      "disabled": !_vm.jobSettingInfo.enabledReport
    },
    model: {
      value: (_vm.jobSettingInfo.rerun),
      callback: function($$v) {
        _vm.$set(_vm.jobSettingInfo, "rerun", $$v)
      },
      expression: "jobSettingInfo.rerun"
    }
  })], 1)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.$option.isPassive(_vm.jobSettingInfo.jobType)) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "upStream",
      "label": "上游作业"
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "bottom"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                                        满足上游作业的条件"), _c('br'), _vm._v("1.只能是定时作业或被动作业"), _c('br'), _vm._v("2.分片只能为1"), _c('br'), _vm._v("3.不能是本地模式作业"), _c('br'), _vm._v("4.不能是本作业的直接或者间接下游\n                                    ")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "multiple": ""
    },
    model: {
      value: (_vm.jobSettingInfo.upStream),
      callback: function($$v) {
        _vm.$set(_vm.jobSettingInfo, "upStream", $$v)
      },
      expression: "jobSettingInfo.upStream"
    }
  }, _vm._l((_vm.jobSettingInfo.upStreamProvided), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$option.isCron(_vm.jobSettingInfo.jobType) || _vm.$option.isPassive(_vm.jobSettingInfo.jobType)) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "downStream",
      "label": "下游作业"
    }
  }, [_c('div', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("\n                                    下游作业\n                                    "), _c('el-tooltip', {
    attrs: {
      "content": "查看作业依赖图",
      "placement": "top"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.handleArrangeLayout()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search-plus"
  })])], 1)], 1), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "placement": "bottom"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                                        配置下游作业的条件"), _c('br'), _vm._v("1.只能是定时作业或被动作业"), _c('br'), _vm._v("2.分片只能为1"), _c('br'), _vm._v("3.不能是本地模式作业"), _c('br'), _c('br'), _vm._v("\n                                        满足下游作业的条件"), _c('br'), _vm._v("1.只能是被动作业"), _c('br'), _vm._v("2.不能是本作业的直接或者间接上游\n                                    ")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "multiple": "",
      "disabled": _vm.jobSettingInfo.localMode || _vm.jobSettingInfo.shardingTotalCount !== 1
    },
    model: {
      value: (_vm.jobSettingInfo.downStream),
      callback: function($$v) {
        _vm.$set(_vm.jobSettingInfo, "downStream", $$v)
      },
      expression: "jobSettingInfo.downStream"
    }
  }, _vm._l((_vm.jobSettingInfo.downStreamProvided), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "channelName",
      "label": "执行结果发送的Channel名"
    }
  }, [_c('el-tooltip', {
    attrs: {
      "popper-class": "form-tooltip",
      "content": "执行消息作业结果发送的channel名，注意不能跟queue绑定的channel一致，以免造成死循环",
      "placement": "bottom"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.jobSettingInfo.channelName),
      callback: function($$v) {
        _vm.$set(_vm.jobSettingInfo, "channelName", $$v)
      },
      expression: "jobSettingInfo.channelName"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.$option.isCron(_vm.jobSettingInfo.jobType)) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "pausePeriodDate",
      "label": "暂停日期段"
    }
  }, [_c('el-tooltip', {
    attrs: {
      "popper-class": "form-tooltip",
      "content": "日期时间段，支持多个日期段。例如03/12-03/15。当日期为空，时间段不为空，表示每天那些时间段都暂停",
      "placement": "bottom"
    }
  }, [_c('InputTags', {
    attrs: {
      "dynamic-tags": _vm.jobSettingInfo.pausePeriodDate,
      "title": "日期段"
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$option.isCron(_vm.jobSettingInfo.jobType)) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "pausePeriodTime",
      "label": "暂停时间段"
    }
  }, [_c('el-tooltip', {
    attrs: {
      "popper-class": "form-tooltip",
      "content": "日期时间段，支持多个时间段。例如12:23-13:23。当日期为不空，时间段为空，表示那些日期段24小时都暂停。针对跨日的时间段，\n                                编辑时需要分成2个段，以23:00-03:00为例，需写成23:00-23:59和00:00-03:00",
      "placement": "bottom"
    }
  }, [_c('InputTags', {
    attrs: {
      "dynamic-tags": _vm.jobSettingInfo.pausePeriodTime,
      "title": "时间段"
    }
  })], 1)], 1)], 1)], 1) : _vm._e()], 1)], 2)], 1), _vm._v(" "), (_vm.$common.hasPerm('job:update', _vm.domainName)) ? _c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary",
      "disabled": _vm.jobSettingInfo.enabled
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.updateInfo($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-database"
  }), _vm._v("更新")]) : _vm._e()], 1), _vm._v(" "), (_vm.isCronPredictVisible) ? _c('div', [_c('CronPredictDialog', {
    attrs: {
      "cron-predict-params": _vm.cronPredictParams
    },
    on: {
      "close-dialog": _vm.closeCronDialog
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isArrangeLayoutVisible) ? _c('div', [_c('arrange-layout-dialog', {
    attrs: {
      "arrange-layout-info": _vm.arrangeLayoutInfo
    },
    on: {
      "job-redirect": _vm.jobRedirect,
      "close-dialog": _vm.closeArrangeLayoutDialog
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-beb74394"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/job_detail/job_setting.vue
// module id = 1439
// module chunks = 1